export const SET_SIZE = 'SET_SIZE';

export default {};
